import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

/**
 * Aura mit der mandantenspezifischen Primaerfarbe.
 *
 * --color-primary / --color-primary-dark / --color-primary-darker werden zur Laufzeit ueber die
 * in index.html eingebundene /custom.css gesetzt (pro Mandant gemountet). Die Tokens verweisen
 * deshalb auf die CSS-Variablen statt auf feste Werte; die restlichen Palettenstufen werden
 * daraus per color-mix() abgeleitet, damit keine weiteren Variablen vorausgesetzt werden.
 *
 * Alles, was ueber diese Tokens loesbar ist, gehoert hierher und nicht nach
 * assets_dev/styles/primeng-overwrite.scss.
 */
const primary = 'var(--color-primary)';
const primaryDark = 'var(--color-primary-dark)';
const primaryDarker = 'var(--color-primary-darker)';

const tint = (percent: number) => `color-mix(in srgb, ${primary} ${percent}%, #ffffff)`;

export const AuexPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: tint(8),
      100: tint(16),
      200: tint(32),
      300: tint(56),
      400: tint(80),
      500: primary,
      600: primaryDark,
      700: primaryDark,
      800: primaryDarker,
      900: primaryDarker,
      950: primaryDarker,
      color: primary,
      contrastColor: '#ffffff',
      hoverColor: primaryDark,
      activeColor: primaryDarker
    },
    // Auswahl-Zustaende (Select-, MultiSelect-, Listbox-Optionen, Tree-Knoten, ...)
    highlight: {
      background: primary,
      focusBackground: primaryDark,
      color: '#ffffff',
      focusColor: '#ffffff'
    }
  },
  components: {
    // Helles Tooltip statt Auras dunklem Default - der Pfeil zieht seine Farbe aus demselben Token.
    tooltip: {
      root: {
        background: '#ffffff',
        color: '#000000',
        fontSize: '0.85em',
        maxWidth: '20rem'
      }
    }
  }
});
